import React from 'react'

const ToTop = () => {
  return (
    <>
      <button id='to_top'>fa</button>

    </>
  )
}

export default ToTop
